import { injectable, interfaces } from 'inversify';
import { computed, IObservableArray, makeObservable, observable } from 'mobx';
import { SortingDirection } from '../../../../models/sortingDirection.model';
import { IClarification } from './models/Clarifications.models';

export interface IClarificationsStore {
  // data
  readonly question: string;
  readonly clarification: IClarification | undefined;
  readonly archiveClarifications: IObservableArray<IClarification>;
  readonly hasUnansweredClarification: boolean;
  readonly clarificationsListSortDirection: SortingDirection;
  setArchiveClarifications(clarifications: IClarification[]): void;
  setClarificationsListSortDirection(sortDirection: SortingDirection): void;
  setQuestion(question: string): void;
  clear(): void;
}

export namespace IClarificationsStore {
  export const $: interfaces.ServiceIdentifier<IClarificationsStore> = Symbol('CLARIFICATIONS_STORE');
}

@injectable()
export class ClarificationsStore implements IClarificationsStore {
  constructor() {
    makeObservable(this, {
      clarification: computed,
      hasUnansweredClarification: computed,
      archiveClarifications: observable,
      clarificationsListSortDirection: observable,
      question: observable,
    });
  }

  get clarification(): IClarification | undefined {
    const notReadClarifications = this.archiveClarifications.filter((c) => !c.isRead);

    if (!notReadClarifications.length) {
      return undefined;
    }

    return notReadClarifications.sort((a, b) => new Date(b.askedDate).getTime() - new Date(a.askedDate).getTime())[0];
  }

  get hasUnansweredClarification(): boolean {
    return this.clarification?.answer === null;
  }

  archiveClarifications: IObservableArray<IClarification> = observable.array([]);

  clarificationsListSortDirection: SortingDirection = SortingDirection.DESC;

  question: string = '';

  setArchiveClarifications(archiveClarifications: IClarification[]): void {
    this.archiveClarifications.replace(archiveClarifications);
  }

  setClarificationsListSortDirection(sortDirection: SortingDirection): void {
    this.clarificationsListSortDirection = sortDirection;
  }

  setQuestion(question: string): void {
    this.question = question;
  }

  clear(): void {
    this.archiveClarifications.replace([]);
  }
}
